module.exports = __webpack_public_path__ + "img/envelope.d64c7411.svg";